import { Presence } from 'Roblox';

// Common Types
export enum TCreatorType {
  User = 'User',
  Group = 'Group'
}

export type TMetaData = {
  suggestedKeyword?: string;
  correctedKeyword?: string;
  filteredKeyword?: string;
  hasMoreRows: boolean;
  featuredSearchUniverseId?: number;
  emphasis: boolean;
  algorithm: string;
  algorithmQueryType: string;
  suggestionAlgorithm: string;
};

export type TGameData = {
  creatorId: number;
  creatorName: string;
  creatorType: TCreatorType;
  totalUpVotes: number;
  totalDownVotes: number;
  universeId: number;
  name: string;
  placeId: number;
  playerCount: number;
  imageToken: string;
  isSponsored: boolean;
  nativeAdData: string;
  isShowSponsoredLabel: boolean;
  price?: number;
  analyticsIdentifier?: string;
  gameDescription?: string;
};

export type TPresence = {
  gameId?: string;
  lastLocation: string;
  lastOnline: string;
  placeId?: number;
  placeUrl?: string;
  rootPlaceId?: number;
  universeId?: number;
  userId: number;
  userPresenceType: typeof Presence.PresenceTypes[keyof typeof Presence.PresenceTypes];
};

// GetOmniRecommendations
export enum TPageType {
  Home = 'Home',
  Games = 'Games'
}

export enum TContentType {
  Games = 'Games'
}

export type TOmniRecommendation = { ContentType: TContentType; ContentId: number };

export type TOmniRecommendationSort = {
  Topic: string;
  TopicId: number;
  RecommendationList: TOmniRecommendation[];
};

export type TGetOmniRecommendationsMetadataResponse = {
  ContentMetadata: {
    [TContentType.Games]: Record<number, TGameData>;
  };
};

export type TGetOmniRecommendationsResponse = {
  Sorts: TOmniRecommendationSort[];
} & TGetOmniRecommendationsMetadataResponse;

// GetGameList
export type TGetGamesListResponse = {
  games: TGameData[];
} & TMetaData;

// GetGameDetails
export type TGetGameDetails = {
  placeId: number;
  name: string;
  description: string;
  url: string;
  builder: string;
  builderId: number;
  isPlayable: boolean;
  reasonProhibited: string;
  universeId: number;
  universeRootPlaceId: number;
  price: number;
  imageToken: string;
};

// GetFriends
export type TGetFriendsResponse = {
  isOnline: boolean;
  isDeleted: boolean;
  description?: string;
  created: string;
  isBanned: boolean;
  id: number;
  name: string;
  displayName: string;
  presence?: TPresence;
  profileUrl?: string;
};

// GetPresenceUpdate
export type TPresenseUpdateEvent = CustomEvent<TPresence[] | undefined>;
